import { useLanguage } from '@hooks/useLanguage';

export function useMastercardLandingUrl() {
  const language = useLanguage();
  const outputLanguage = ['en', 'uk'].includes(language) ? language : 'en';
  return `https://mastercard.edopomoga.gov.ua/${outputLanguage}`;
}
